<template>
  <section class="app-login">
    <section class="app-login-wrap">
      <h2 class="title">登录</h2>
      <el-form ref="form" :model="form" :rules="rules">
        <template v-if="needCode">
          <el-form-item label="请联系董事长获取验证码" prop="chairmanCode">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-input placeholder="请输入验证码" maxlength="6" v-model="form.chairmanCode"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="手机号" prop="mobile">
            <el-row :gutter="20">
              <el-col :span="15">
                <el-input placeholder="请输入手机号" maxlength="11" v-model="form.mobile"></el-input>
              </el-col>
              <el-col :span="4">
                <el-button @click="getMobileCodeBtn" :disabled="disadle">{{ massage }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-input placeholder="请输入验证码" maxlength="6" v-model="form.code"></el-input>
              </el-col>
              <el-col :span="8">
                <el-link type="primary" :underline="false">有限期60秒</el-link>
              </el-col>
            </el-row>
          </el-form-item>
        </template>
        <el-form-item class="form-button">
          <el-button @click="submitForm" type="primary" class="form-button">登录</el-button>
        </el-form-item>
        <el-row style="text-align:center;margin-top:20px">
                <el-link type="primary" :underline="false" @click="$router.push('/home')">返回首页</el-link></el-row>
      </el-form>
    </section>
    <loginMovieBg />
  </section>
</template>

<script>
import loginMovieBg from './components/loginMovieBg'
import { getMobileCode, loginWithMobileCode, doubleCheck } from '@/api/smsLogin'
import { validPhone } from '@/assets/scripts/validate'
export default {
  name: 'appLogin',
  // inject: ['reload'], // 注入刷新内容
  components: {
    loginMovieBg
  },
  data() {
    return {
      needCode: false,
      form: {
        mobile: '',
        code: '',
        chairmanCode: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { validator: validPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        chairmanCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      massage: "获取验证码",
      disadle: false,
      count: 60
    }
  },
  mounted() {
    if (localStorage.getItem('jiadingFangwu_token')) {
      this.$router.push('overview')
    }
  },
  methods: {
    submitForm() {
      if (this.needCode) {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let res = await doubleCheck({
              code: this.form.chairmanCode
            })
            const { code, result } = res
            if (code === 0 && result) {
              this.$router.push('overview')
            } else {
              this.$message.error('验证码错误')
            }
          }
        })
      } else {
        localStorage.clear()
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let res = await loginWithMobileCode({
              code: this.form.code,
              mobile: this.form.mobile
            })
            if (res.code === 0) {
              // this.reload() // 强制刷新，更新路由
              await this.$base.setLocalStorage('userInfo', res.result.userInfoEntity) // 登录用户信息 roleName等
              await this.$base.setLocalStorage('userPageInfo', res.result.pagesSet) // 用户页面权限
              await this.$base.setLocalStorage('userInfo_roleName', res.result.userInfoEntity.roleName)
              await this.$base.setLocalStorage('userInfo_userCompanyRelRespList', res.result.userCompanyRelRespList)
              await this.$base.setLocalStorage('token', res.result.token)
              if (res.result.userInfoEntity.roleName === '管理员') {
                this.needCode = true
              } else {
                this.$router.push('overview')
              }
            }
          } else {
            return false
          }
        })
      }
    },
    getMobileCodeBtn () {
      this.$refs.form.validateField('mobile', (valid) => {
        if (!valid) {
          // 发送验证码
          getMobileCode({
            mobile: this.form.mobile
          }).then(res => {
            if (res) {
              this.$message.success('短信发送成功')
              // 倒计时
              this.verificationCode()
            }
          })
        }
      })
    },
    verificationCode() {
      this.massage = "重新获取(" + this.count + ")";
      this.count--;
      if (this.count <= 0) {
        this.count = 60;
        this.massage = "获取验证码";
        this.disadle = false;
      } else {
        this.disadle = true;
        setTimeout(() => {
          this.verificationCode();
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-login-wrap {
  width: 4.7rem;
  // height: 5.1rem;
  // height: 70%;
  position: absolute;
  z-index: 99;
  left: 50%;
  top: 40%;
  margin: -2.4rem 0 0 -1.8rem;
  background: #fff;
  background-size: cover;
  box-shadow: 0.02rem 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.15);
  color: #333;
  border-radius: 10px;

  h2 {
    font-size: 0.16rem;
    text-align: center;
    margin: 0.15rem 0;
  }

  .el-form {
    margin: 0.25rem;

    .el-form-item {
      margin-bottom: 0.08rem;
    }

    /deep/ .el-form-item__label {
      float: none;
    }

    .verify-code {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .verify-code-input {
        float: left;
        width: 70%;
      }

      .code-img {
        margin-left: 0.08rem;
        cursor: pointer;
      }
    }

    .form-button {
      text-align: center;
      width: 100%;
      margin-top: 0.15rem;
    }
  }
}
</style>
